import { createSelector } from 'reselect';

import { createKeySelector } from 'Lib/reduxUtils';

const selectIntent = createKeySelector('intent');

export const getIntentParsedResult = createSelector(selectIntent, (intent) => intent.parsedResult);
